module.exports = __webpack_public_path__ + "img/tshirttime.a002a1b7.png";